import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout";

Vue.use(VueRouter);

const routes = [
  {
    name: "Login",
    path: "/login",
    component: () => import("@/views/Login"),
  },
  {
    name: "ssoLogin",
    path: "/ssologin",
    component: () => import("@/views/Login/ssologin.vue"),
  },
  {
    name: "QuestForm",
    path: "/qst/:key",
    component: () => import("@/views/Quest/view.vue"),
  },
  // {
  //   name: "Questionnaire",
  //   path: "/q-detail-1",
  //   component: () =>
  //     import("@/views/Patient/components/questionnaire/detail/q-detail-1.vue"),
  // },
  {
    path: "/",
    component: Layout,
    children: [
      {
        name: "Home",
        path: "/",
        component: () => import("@/views/Home"),
      },
      {
        path: "/about",
        component: () => import("@/views/About.vue"),
      },
    ],
  },
  {
    path: "/common",
    component: Layout,
    children: [
      {
        name: "Common/FindPatient",
        path: "findPatient",
        component: () => import("@/views/FindPatientCommon/index.vue"),
      },
    ],
  },
  {
    path: "/patient",
    component: Layout,
    children: [
      {
        name: "Patient/Group",
        path: "group",
        component: () => import("@/views/Patient/group.vue"),
      },
      {
        name: "Patient/GroupView",
        path: "group_view",
        component: () => import("@/views/Patient/group_view.vue"),
      },
      {
        name: "Patient/List",
        path: "list",
        component: () => import("@/views/Patient/list.vue"),
      },
      {
        name: "Patient/User",
        path: "user",
        component: () => import("@/views/Patient/user.vue"),
      },
      {
        name: "Patient/NoIdentity",
        path: "no-identity",
        component: () => import("@/views/Patient/no_identity.vue"),
      },
    ],
  },
  {
    path: "/hospital",
    component: Layout,
    children: [
      {
        name: "Hospital/Common",
        path: "common",
        component: () => import("@/views/Hospital/common.vue"),
      },
      {
        name: "Hospital",
        path: "index",
        component: () => import("@/views/Hospital/index.vue"),
      },
      {
        name: "Hospital/In",
        path: "hospital_in",
        component: () => import("@/views/Hospital/hospital_in.vue"),
      },
      {
        name: "Hospital/Out",
        path: "hospital_out",
        component: () => import("@/views/Hospital/hospital_out.vue"),
      },
      {
        name: "Hospital/Unmanaged",
        path: "unmanaged",
        component: () => import("@/views/Hospital/unmanaged.vue"),
      },
      {
        name: "Hospital/Dispense",
        path: "dispense",
        component: () => import("@/views/Hospital/dispense.vue"),
      },
    ],
  },
  {
    path: "/schedule-outpatient",
    component: Layout,
    children: [
      {
        name: "Schedule-OP",
        path: "index",
        component: () => import("@/views/Schedule-OP/index.vue"),
      },
      {
        name: "Schedule-OP/Schedule",
        path: "schedule",
        component: () => import("@/views/Schedule-OP/schedule.vue"),
      },
      {
        name: "Schedule-OP/Dispense",
        path: "dispense",
        component: () => import("@/views/Schedule-OP/dispense.vue"),
      },
      {
        name: "Schedule-OP/Expire",
        path: "expire",
        component: () => import("@/views/Schedule-OP/expire.vue"),
      },
    ],
  },
  {
    path: "/schedule",
    component: Layout,
    children: [
      {
        name: "Schedule/Common",
        path: "common",
        component: () => import("@/views/Schedule/common.vue"),
      },
      {
        name: "Schedule",
        path: "index",
        component: () => import("@/views/Schedule/index.vue"),
      },
      {
        name: "Schedule/Schedule",
        path: "schedule",
        component: () => import("@/views/Schedule/schedule.vue"),
      },
      {
        name: "Schedule/Dispense",
        path: "dispense",
        component: () => import("@/views/Schedule/dispense.vue"),
      },
      {
        name: "Schedule/Expire",
        path: "expire",
        component: () => import("@/views/Schedule/expire.vue"),
      },
    ],
  },
  {
    path: "/follow",
    component: Layout,
    children: [
      {
        name: "Follow/Common",
        path: "common",
        component: () => import("@/views/Follow/common.vue"),
      },
      {
        name: "Follow",
        path: "index",
        component: () => import("@/views/Follow/index.vue"),
      },
      {
        name: "Follow/Follow",
        path: "follow",
        component: () => import("@/views/Follow/follow.vue"),
      },

      {
        name: "Follow/Drafts",
        path: "drafts",
        component: () => import("@/views/Follow/drafts.vue"),
      },
      {
        name: "Follow/Terminate",
        path: "terminate",
        component: () => import("@/views/Follow/terminate.vue"),
      },
    ],
  },
  {
    path: "/continuity-care",
    component: Layout,
    children: [
      // {
      // 	name: 'Continuity-Care/Completed',
      // 	path: 'completed',
      // 	component: () => import('@/views/ContinuityCare/completed.vue')
      // },
      {
        name: "Continuity-Care",
        path: "index",
        component: () => import("@/views/ContinuityCare/index.vue"),
      },
    ],
  },
  {
    path: "/subsequent",
    component: Layout,
    children: [
      {
        name: "Subsequent/Common",
        path: "common",
        component: () => import("@/views/Subsequent/common.vue"),
      },
      {
        name: "Subsequent",
        path: "index",
        component: () => import("@/views/Subsequent/index.vue"),
      },
      {
        name: "Subsequent/Visits",
        path: "visits",
        component: () => import("@/views/Subsequent/visits.vue"),
      },
      {
        name: "Subsequent/Unvisits",
        path: "unvisits",
        component: () => import("@/views/Subsequent/unvisits.vue"),
      },
      {
        name: "Subsequent/Revisit",
        path: "revisit",
        component: () => import("@/views/Subsequent/reVisit.vue"),
      },
    ],
  },
  {
    path: "/contract",
    component: Layout,
    children: [
      {
        name: "Contract/Common",
        path: "common",
        component: () => import("@/views/Contract/common.vue"),
      },
      {
        name: "Contract",
        path: "index",
        component: () => import("@/views/Contract/index.vue"),
      },
      {
        name: "Contract/Signed",
        path: "signed",
        component: () => import("@/views/Contract/signed.vue"),
      },
      {
        name: "Contract/Renew",
        path: "renew",
        component: () => import("@/views/Contract/renew.vue"),
      },
      {
        name: "Contract/NoIntention",
        path: "no_intention",
        component: () => import("@/views/Contract/no_intention.vue"),
      },
    ],
  },
  // {
  // 	path: '/quest',
  // 	component: Layout,
  // 	children: [
  // 		{
  // 			name: 'Quest',
  // 			path: 'index',
  // 			component: () => import('@/views/Quest/index.vue')
  // 		},
  // 		{
  // 			name: 'Quest/View',
  // 			path: 'view',
  // 			component: () => import('@/views/Quest/view.vue')
  // 		},
  // 	]
  // },
  {
    path: "/statistics",
    component: Layout,
    children: [//liverCancerScreening
    {
      name: "Statistics/AnnualReport",
      path: "annualReport",
      component: () => import("@/views/Statistics/annualReport.vue"),
    },
      {
        name: "Statistics/LiverCancerScreening",
        path: "liverCancerScreening",
        component: () => import("@/views/Statistics/liverCancerScreening.vue"),
      },
      {
        name: "Statistics/Schedule",
        path: "schedule",
        component: () => import("@/views/Statistics/schedule.vue"),
      },
      {
        name: "Statistics/Department",
        path: "department",
        component: () => import("@/views/Statistics/department.vue"),
      },
      {
        name: "Statistics/Follow",
        path: "follow",
        component: () => import("@/views/Statistics/follow.vue"),
      },
      {
        name: "Statistics/Manage",
        path: "manage",
        component: () => import("@/views/Statistics/manage.vue"),
      },
      // 门诊统计
      {
        name: "Statistics/Schedule2",
        path: "schedule2",
        component: () => import("@/views/Statistics/schedule2.vue"),
      },
      {
        name: "Statistics/Department2",
        path: "department2",
        component: () => import("@/views/Statistics/department2.vue"),
      },
      {
        name: "Statistics/Follow2",
        path: "follow2",
        component: () => import("@/views/Statistics/follow2.vue"),
      },
      {
        name: "Statistics/Manage2",
        path: "manage2",
        component: () => import("@/views/Statistics/manage2.vue"),
      },

      {
        name: "Statistics/Return",
        path: "return",
        component: () => import("@/views/Statistics/return.vue"),
      },
      {
        name: "Statistics/Return2",
        path: "return2",
        component: () => import("@/views/Statistics/return2.vue"),
      },
      {
        name: "Statistics/Return3",
        path: "return3",
        component: () => import("@/views/Statistics/return3.vue"),
      },
      {
        name: "Statistics/HospitalIn",
        path: "HospitalIn",
        component: () => import("@/views/Statistics/hospitalIn.vue"),
      },
      {
        name: "Statistics/Evaluated",
        path: "Evaluated",
        component: () => import("@/views/Statistics/evaluated.vue"),
      },
      {
        name: "Statistics/Prescription",
        path: "Prescription",
        component: () => import("@/views/Statistics/prescription.vue"),
      },
      {
        name: "Statistics/Questionnaire",
        path: "questionnaire",
        component: () => import("@/views/Statistics/questionnaire.vue"),
      },
      {
        name: "Statistics/QuestionnaireStatistics",
        path: "questionnaireStatistics",
        component: () => import("@/views/Statistics/questionnaireStatistics.vue"),
      },
      {
        name: "Statistics/HealthQuotient",
        path: "healthQuotient",
        component: () => import("@/views/Statistics/healthQuotient.vue"),
      },
    ],
  },
  {
    path: "/system",
    component: Layout,
    children: [
      {
        name: "System/Department",
        path: "department",
        component: () => import("@/views/System/department.vue"),
      },
      {
        name: "System/Disease",
        path: "disease",
        component: () => import("@/views/System/disease.vue"),
      },

      {
        name: "System/User",
        path: "user",
        component: () => import("@/views/System/user.vue"),
      },
      {
        name: "System/Role",
        path: "role",
        component: () => import("@/views/System/role.vue"),
      },
      {
        name: "System/Org",
        path: "org",
        component: () => import("@/views/System/org.vue"),
      },
      {
        name: "System/Rule",
        path: "rule",
        component: () => import("@/views/System/rule.vue"),
      },
      {
        name: "System/Menu",
        path: "menu",
        component: () => import("@/views/System/menu.vue"),
      },

      {
        name: "System/ScheduleTemplate",
        path: "scheduleTemplate",
        component: () => import("@/views/System/scheduleTemplate.vue"),
      },

      {
        name: "System/ScheduleTemplateView",
        path: "scheduleTemplate_view",
        component: () => import("@/views/System/scheduleTemplate_view.vue"),
      },

      {
        name: "System/ErrorMsg",
        path: "errorMsg",
        component: () => import("@/views/System/errorMsg.vue"),
      },
      {
        name: "System/SmsSend",
        path: "smsSend",
        component: () => import("@/views/System/sms/smsSend.vue"),
      },
      {
        name: "System/SmsCount",
        path: "smsCount",
        component: () => import("@/views/System/sms/smsCount.vue"),
      },
      {
        name: "System/Questionnair",
        path: "questionnair",
        component: () => import("@/views/System/questionnair.vue"),
      },
      {
        name: "System/DataBatchModify",
        path: "dataBatchModify",
        component: () =>
          import("@/views/System/dataManage/dataBatchModify.vue"),
      },
      {
        name: "System/DashboardConfig",
        path: "dashboardConfig",
        component: () => import("@/views/System/dashboardConfig.vue"),
      },
      {
        name: "System/SyncPatient",
        path: "syncPatient",
        component: () => import("@/views/System/syncPatient.vue"),
      },
      {
        name: "System/SyncList",
        path: "syncList",
        component: () => import("@/views/System/syncList.vue"),
      },
      {
        name: "System/Info",
        path: "info",
        component: () => import("@/views/System/myData.vue"),
      },
      {
        name: "System/PushLogs",
        path: "pushLogs",
        component: () => import("@/views/System/pushLogs.vue"),
      },
      {
        name: "System/SmsTemplate",
        path: "smsTemplate",
        component: () => import("@/views/System/smsTemplate.vue"),
      },
    ],
  },
  {
    name: "Dashboard",
    path: "/dashboard",
    component: () => import("@/views/DashBoard"),
  },
];

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

function checkLogin() {
  let user = localStorage.getItem("user");
  if (!user || user == "") {
    return false;
  }
  user = JSON.parse(user);
  if (+user.expire < +new Date()) {
    // 过期
    return false;
  }
  return true;
}

const router = new VueRouter({
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (["Login", "QuestForm", "ssoLogin"].includes(to.name)) {
    next();
  } else {
    // 权限验证
    if (!checkLogin()) {
      next({ name: "Login", query: { r: location.href } });
      return;
    }
    // 获取用户菜单与权限
    // if (store.state.menu.length == 0) {
    // 	let res = await api.getUserMenu();
    // 	store.commit('initPermission', res.data);
    // }
    next();
  }
});

export default router;
